
import { supabase } from '@/integrations/supabase/client';

/**
 * Bulk create products with just names
 * @param productNames Array of product names to create
 * @returns Information about created and skipped products
 */
export const bulkCreateProducts = async (productNames: string[]) => {
  try {
    // First, get existing products to check for duplicates
    const { data: existingProducts, error: fetchError } = await supabase
      .from('products')
      .select('name');
    
    if (fetchError) throw fetchError;
    
    // Get unique new products to add (case insensitive)
    const existingNames = existingProducts ? new Set(existingProducts.map(product => product.name.toLowerCase())) : new Set();
    const newProducts = productNames.filter(name => !existingNames.has(name.toLowerCase()));
    
    if (newProducts.length === 0) {
      return { skipped: productNames.length, added: 0 };
    }
    
    const productsToInsert = newProducts.map(name => ({ name }));
    
    const { data, error } = await supabase
      .from('products')
      .insert(productsToInsert);
    
    if (error) throw error;
    
    return { 
      data,
      added: newProducts.length, 
      skipped: productNames.length - newProducts.length 
    };
  } catch (error) {
    console.error("Error in bulk create products:", error);
    throw error;
  }
};
